// Reference: https://ckeditor.com/docs/ckfinder/ckfinder3/?mobile=/api/CKFinder.Application
export interface CkFinderDataType {
  isOpen: boolean;
  config: {
    connectorPath: string;
    connectorInfo: string;
    chooseFiles: boolean;
    width: number;
    height: number;
  };
  selectedFileName?: string;
}

export enum CkFinderResourceTypeEnum {
  VIDEOS = 'Videos',
  IMAGES = 'Images',
  RESOURCES = 'Resources',
  SOUNDS = 'Sounds',
}

export enum AssetFileTypeEnum {
  VIDEOS = 'videos',
  IMAGES = 'images',
  RESOURCES = 'resources',
  SOUNDS = 'sounds',
}

export enum AssetEntityEnum {
  elearning = 'elearnings',
  quiz = 'quizzes',
  theme = 'themes',
}

export interface CKFinderFileInterface {
  get: (value: string) => any;
  [key: string]: any;
}

export interface CKFinderEventInfoInterface {
  data: unknown & { files: CKFinderFileInterface[] };
  listenerData: object;
  name: string;
  sender: object;
  cancel: () => void;
  stop: () => void;
  [key: string]: any;
}

export interface CKFinderApplicationInterface {
  on: (
    eventName: string,
    listenerFunction: (event: CKFinderEventInfoInterface) => void,
    scopeObj?: object[],
    priority?: number[],
  ) => void;
  [key: string]: any;
}

export type CKFileKindType = 'images' | 'videos' | 'sounds' | 'resources';

export type CKConfigArgsType = {
  type: CkFinderResourceTypeEnum[];
  tenantId: string;
  entityId: string;
};

export type CKConfigType = {
  connectorInfo: string;
  connectorPath: string;
};

export type CKModuleType = 'quizzes' | 'elearnings' | 'themes';
